import { render, staticRenderFns } from "./section.vue?vue&type=template&id=7117a6a8&"
import script from "./section.vue?vue&type=script&lang=js&"
export * from "./section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "section.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/business/select-member/section.vue
// module id = 179
// module chunks = 0